import { Group, Text, TextInput } from "@mantine/core";
import classes from "./SearchInputWithCount.module.css";

export default function SearchInputWithCount({
  placeholder,
  value,
  onChange,
  count,
}: {
  placeholder: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  count: number;
}) {
  return (
    <Group className={classes.searchWrapper} justify="space-between" align="center">
      <TextInput
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        size="md"
        radius="md"
        className={classes.searchInput}
      />
      <Text className={classes.countText}>Showing {count}</Text>
    </Group>
  );
}
